import { useEffect, useState, useCallback } from 'react'
import { CheckCircle2, XCircle, AlertCircle, Info, X } from 'lucide-react'
import './Toast.css'

/**
 * Componente Toast para exibir notificações modernas
 * 
 * @param {string} message - Mensagem a ser exibida
 * @param {string} type - Tipo: 'success', 'error', 'warning', 'info'
 * @param {boolean} show - Se deve mostrar o toast
 * @param {function} onClose - Função chamada quando o toast é fechado
 * @param {number} duration - Duração em ms (padrão: 3000)
 */
function Toast({ message, type = 'info', show = false, onClose, duration = 3000 }) {
  const [isVisible, setIsVisible] = useState(show)

  const handleClose = useCallback(() => {
    setIsVisible(false)
    if (onClose) {
      setTimeout(onClose, 300) // Aguardar animação de saída
    }
  }, [onClose])

  useEffect(() => {
    setIsVisible(show)
    
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        handleClose()
      }, duration)
      
      return () => clearTimeout(timer)
    }
  }, [show, duration, handleClose])

  if (!isVisible && !show) return null

  const icons = {
    success: <CheckCircle2 size={20} />,
    error: <XCircle size={20} />,
    warning: <AlertCircle size={20} />,
    info: <Info size={20} />
  }

  const icon = icons[type] || icons.info

  return (
    <div className={`toast toast-${type} ${isVisible ? 'toast-show' : 'toast-hide'}`}>
      <div className="toast-content">
        <div className="toast-icon">{icon}</div>
        <div className="toast-message">{message}</div>
        <button className="toast-close" onClick={handleClose} aria-label="Fechar">
          <X size={16} />
        </button>
      </div>
    </div>
  )
}

export default Toast

